{
  "welcome.title": "Ihr Kind hat so viel zu sagen",
  "welcome.body": "Beantworten Sie ein paar kurze Fragen und Timo erstellt einen kostenlosen, persönlichen Plan, der Ihrem Kind hilft, seine Stimme zu finden. Das dauert etwa 90 Sekunden.",
  "welcome.cta": "Jetzt starten",
  "gender.question": "Ist Ihr Kind ein Junge oder ein Mädchen?",
  "gender.opt.boy": "Junge",
  "gender.opt.girl": "Mädchen",
  "age.question": "Wie alt ist Ihr Kind?",
  "age.sub": "Damit Timo die passenden Fragen für dieses Alter stellt.",
  "age.opt.under3": "Unter 3",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "name.question": "Wie heißt Ihr Kind?",
  "name.sub": "Oder ein Spitzname, damit Timo persönlich wird.",
  "name.placeholder": "Name Ihres Kindes",
  "words.question": "Wie viele Wörter kann {name} ungefähr sagen?",
  "words.sub": "Eine grobe Schätzung reicht völlig.",
  "words.opt.0": "0 Wörter",
  "words.opt.1-5": "1-5 Wörter",
  "words.opt.6-10": "6-10 Wörter",
  "words.opt.11-50": "11-50 Wörter",
  "words.opt.50+": "50+ Wörter",
  "words.opt.unsure": "Nicht sicher",
  "sentences.question": "Spricht {name} in längeren Sätzen (4-6 Wörter) mit meist korrekter Grammatik?",
  "sentences.opt.yes": "Ja",
  "sentences.opt.no": "Nein",
  "delay_fact.title": "Ein früher Start macht den größten Unterschied",
  "delay_fact.body": "Ein paar Minuten am Tag mit Timo, und {name} freut sich darauf.",
  "delay_fact.cta": "Weiter",
  "calc.title": "Wir erstellen das Kommunikationsprofil für {name}",
  "calc.arr.0": "Wir verstehen, was {name} braucht...",
  "calc.arr.1": "Wir vergleichen mit den Entwicklungsschritten...",
  "calc.arr.2": "Wir wählen die passenden Aktivitäten...",
  "calc.arr.3": "Fast fertig...",
  "calc.review.text": "Mein Sohn kam von ein paar Wörtern zu kurzen Sätzen. Mit Timo will er selbst sprechen.",
  "calc.review.author": "Rasa, Mutter eines 4-Jährigen",
  "score.title": "Kommunikationsprofil für {name}",
  "score.arr.0": "Sprechen",
  "score.arr.1": "Verstehen",
  "score.arr.2": "Gespräch",
  "score.arr.3": "Selbstvertrauen",
  "score.arr.4": "Sozial",
  "score.cta": "Plan für {name} erstellen",
  "voice.question": "Timo-Stimme für {name} auswählen",
  "voice.sub": "Tippen Sie auf eine Karte, um eine Hörprobe zu bekommen.",
  "email.title": "Erstellen Sie Ihr kostenloses Konto",
  "email.sub": "So wird der Plan für {name} gespeichert und Sie können sich jederzeit wieder anmelden.",
  "conversation.question": "Kann {name} ein Gespräch ohne viel Hilfe von Erwachsenen aufrechterhalten?",
  "conversation.opt.yes": "Ja",
  "conversation.opt.no": "Nein",
  "questions.question": "Stellt {name} gern viele Fragen, zum Beispiel „Warum regnet es?“",
  "questions.opt.yes": "Ja",
  "questions.opt.no": "Nein",
  "find_words.question": "Sucht {name} manchmal nach den passenden Worten?",
  "find_words.opt.yes": "Ja",
  "find_words.opt.no": "Nein",
  "sounds.question": "Welche Laute kann {name} deutlich aussprechen?",
  "sounds.sub": "Tippen Sie alles an, was zutrifft. So wählt Timo die passenden Übungen.",
  "sounds.opt.p_b": "P, B  (Post, Buch)",
  "sounds.opt.m_n": "M, N  (Mama, Nase)",
  "sounds.opt.t_d": "T, D  (Tasse, Dose)",
  "sounds.opt.k_g": "K, G  (Kuh, Gabel)",
  "sounds.opt.f_v": "F, W  (Fisch, Wasser)",
  "sounds.opt.l": "L  (Löwe)",
  "sounds.opt.r": "R  (Rakete)",
  "sounds.opt.sh_ch": "SCH, TSCH  (Schuh, Tschüss)",
  "therapist.question": "War {name} schon einmal in einer Sprachtherapie?",
  "therapist.opt.yes": "Ja",
  "therapist.opt.no": "Nein",
  "diagnosis.question": "Hat {name} eine Diagnose bekommen?",
  "diagnosis.sub": "Das bleibt privat und hilft Timo nur bei der Anpassung.",
  "diagnosis.opt.autism": "Autismus / ASS",
  "diagnosis.opt.speech_delay": "Sprachentwicklungsverzögerung",
  "diagnosis.opt.adhd": "ADHS",
  "diagnosis.opt.none": "Keine Diagnose",
  "diagnosis.opt.prefer_not": "Möchte ich nicht sagen",
  "social.question": "Findet {name} Gruppen oder soziale Situationen schwierig?",
  "social.opt.yes": "Ja",
  "social.opt.no": "Nein",
  "goals.question": "Wobei kann Timo {name} am meisten helfen?",
  "goals.sub": "Wählen Sie bis zu 3. Das prägt den ganzen Plan.",
  "goals.opt.confidence": "Sicherer sprechen",
  "goals.opt.conversations": "Alltagsgespräche üben",
  "goals.opt.social": "Schwierige soziale Momente meistern",
  "goals.opt.feelings": "Gefühle gesund ausdrücken",
  "goals.opt.calm": "Ruhig bleiben, wenn alles zu viel wird",
  "goals.opt.school": "Sich auf die Schule vorbereiten",
  "topics.question": "Wählen Sie die Lieblingsthemen von {name}",
  "topics.sub": "Timo baut sie in die Übungen ein.",
  "topics.opt.animals": "Tiere",
  "topics.opt.space": "Weltall",
  "topics.opt.vehicles": "Fahrzeuge",
  "topics.opt.music": "Musik",
  "topics.opt.nature": "Natur",
  "topics.opt.food": "Essen",
  "experts.title": "Mit Fachleuten entwickelt, auf {name} zugeschnitten",
  "experts.body": "Timo Helps folgt einem Rahmen für Sprache und Autismus-Kommunikation und richtet sich dann nach Ihren Antworten zu {name}. Nie eine Lösung für alle.",
  "experts.quote.text": "Über 10.000 Familien nutzen Timo Helps, damit ihr Kind seine Stimme findet.",
  "experts.quote.author": "4,8 Durchschnittsbewertung",
  "experts.cta": "Plan für {name} ansehen",
  "learn_style.question": "Wie lernt {name} am liebsten?",
  "learn_style.opt.hands_on": "Bei praktischen Aktivitäten",
  "learn_style.opt.stories": "Beim Zuhören von Geschichten",
  "learn_style.opt.video": "Beim Videoschauen",
  "learn_style.opt.games": "Beim Spielen",
  "strengths.question": "Was sind die Stärken von {name}?",
  "strengths.sub": "Wählen Sie alles, was passt.",
  "strengths.opt.creative": "Kreativität",
  "strengths.opt.curious": "Neugier",
  "strengths.opt.caring": "Fürsorglichkeit",
  "strengths.opt.determined": "Zielstrebigkeit",
  "strengths.opt.funny": "Humor",
  "challenge.question": "Was ist gerade die größte Herausforderung für {name}?",
  "challenge.opt.frustrated": "Wird schnell frustriert",
  "challenge.opt.distracted": "Ist leicht abgelenkt",
  "challenge.opt.shy": "Schüchtern oder ängstlich mit Menschen",
  "challenge.opt.overwhelmed": "Ist schnell überfordert",
  "daily_time.question": "Wie viel Übung pro Tag ist realistisch?",
  "daily_time.sub": "Schon ein paar Minuten summieren sich schnell.",
  "daily_time.opt.5": "Kleiner Schub",
  "daily_time.hint.5": "5 Min. pro Tag",
  "daily_time.opt.10": "Genau richtig",
  "daily_time.hint.10": "10 Min. pro Tag",
  "daily_time.opt.20": "Volle Kraft",
  "daily_time.hint.20": "20 Min. pro Tag",
  "when.question": "Wann wird {name} üben?",
  "when.opt.morning": "Morgens",
  "when.hint.morning": "Ein ruhiger Start",
  "when.opt.afternoon": "Mittags",
  "when.hint.afternoon": "Ein Schub am Tag",
  "when.opt.evening": "Abends",
  "when.hint.evening": "Zur Ruhe kommen vor dem Schlafen",
  "who_uses.question": "Wer nutzt Timo Helps gemeinsam mit {name}?",
  "who_uses.opt.mom": "Mama",
  "who_uses.opt.dad": "Papa",
  "who_uses.opt.grandparent": "Oma oder Opa",
  "who_uses.opt.specialist": "Therapeut oder Lehrer",
  "who_uses.opt.themselves": "Allein",
  "timeline.question": "Wie schnell möchten Sie Fortschritte sehen?",
  "timeline.opt.weeks": "In ein paar Wochen",
  "timeline.opt.1-2m": "In 1-2 Monaten",
  "timeline.opt.no_rush": "Kein fester Zeitrahmen",
  "main_goal.question": "Was ist gerade Ihr Hauptziel?",
  "main_goal.opt.catch_up": "{name} beim Aufholen helfen",
  "main_goal.opt.on_track": "Fortschritte halten",
  "main_goal.opt.confidence": "Das Selbstvertrauen von {name} stärken",
  "main_goal.opt.other": "Etwas anderes",
  "profile_done.title": "Der komplette Plan für {name} ist fertig",
  "profile_done.body": "Timo hat alles, was er braucht. Lassen Sie uns gemeinsam üben.",
  "profile_done.cta": "Loslegen"
}
